<template>
  <div class="tree-levels">
    <ui-select
      v-model="type"
      @change="levelChanged"
      class="tree-levels__picker"
      menu-content-class="tree-levels__picker-menu"
      :items="tableDimensions1"
      item-text="text"
      item-value="id"
      size="mini"
      :hide-details="1"
      max-width-calc
    ></ui-select>
    <ui-icon class="tree-levels__icon-arrow ml-4" icon="fas fa-angle-right"></ui-icon>
    <ui-select
      v-model="levels[0]"
      @change="levelChanged"
      class="tree-levels__picker ml-4"
      menu-content-class="tree-levels__picker-menu"
      :items="tableDimensions2"
      item-text="text"
      item-value="id"
      size="mini"
      :hide-details="1"
      max-width-calc
    ></ui-select>
    <ui-icon class="tree-levels__icon-arrow ml-4" icon="fas fa-angle-right"></ui-icon>
    <ui-select
      v-model="levels[1]"
      class="ml-4 tree-levels__picker tree-levels--disablable"
      :class="{ 'tree-levels--hidden': isPickerTree1Hidden }"
      menu-content-class="tree-levels__picker-menu"
      :items="tableDimensions3"
      @change="levelChanged"
      item-text="text"
      item-value="id"
      size="mini"
      :disabled="disabled"
      :hide-details="1"
      max-width-calc
    ></ui-select>
  </div>
</template>

<script setup lang="ts">
import { useTreeLevels } from '@/composables/useTreeLevels';

const {
  type,
  levels,
  tableDimensions1,
  tableDimensions2,
  tableDimensions3,
  isPickerTree1Hidden,
  disabled,
  levelChanged,
} = useTreeLevels();
</script>

<style lang="scss">
.tree-levels {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &__picker {
    flex-grow: 0;
    display: flex;
    max-width: 140px;
    min-width: 140px;

    .ui-select__wrapper,
    .ui-select,
    .v-input {
      width: 100%;
      min-width: 0;
    }

    .v-select__selection,
    .v-select__selection-text,
    .v-field__input,
    input {
      text-transform: capitalize;
    }

     @media only screen and (max-width: 959px) {
      flex-grow: 1;
      max-width: unset;
      min-width: 0;
     }
  }

  &__picker-menu {
    .v-list__tile__title {
      text-transform: capitalize;
    }
  }

  &__icon-arrow {
    font-size: 12px;
    color: var(--color-graphite);
  }
}
</style>
